function debounce(func, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), delay);
  };
}

function updateCartNote(cartNote) {
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      note: cartNote,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error("Error:", error);
    });
}

const debounceUpdateCartNote = debounce(updateCartNote, 1000);

document.addEventListener("DOMContentLoaded", (event) => {
  const cartNoteEle = document.querySelector("#bss-cart-note-textarea");
  if (BSS_B2B && cartNoteEle) {
    updateCartNote("");
    cartNoteEle.addEventListener("input", function () {
      debounceUpdateCartNote(this.value);
    });
  }
});

const renderMessage = (value, isCheckout = false, event, noteBox) => {
  const message = noteBox.querySelector('#bss-b2b-note-message');
  if(value.length > 200){
    if(isCheckout && event)  {
       event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
    }
    if(!message){
      const div = document.createElement('div');
      div.textContent = `Maximum 200 characters only`;
      div.style.color = 'red';
      div.id = 'bss-b2b-note-message'
      noteBox.append(div)
    } else {
      message.style.visibility = 'visible';
    }
  } else if(message && value.length <= 200){
    message.style.visibility = 'hidden';
  }
}

setTimeout(() => {
    const noteBox = document.querySelector('.bss-b2b-custom-fields.bss-config-header');
    if(noteBox){
      const textNoteBox = noteBox.querySelector('textarea');
      if(textNoteBox){
          textNoteBox.addEventListener('blur', (event) => {
            const value = textNoteBox.value;
            renderMessage(value, false, event, noteBox)
          })


          //checkout 
          const checkoutBtn = document.querySelector('.cart__buttons-wrapper button[name="checkout"]');
          if(checkoutBtn){
            checkoutBtn.addEventListener('click', (event) => {
                const value = textNoteBox.value;
              renderMessage(value, true, event, noteBox)
            })
          }
        }
        
    }

}, 300)
